import { Component, OnInit } from '@angular/core';
import { CurrentProductService } from "@spartacus/storefront";
import { Observable } from "rxjs";
import { isNotNullable, Product } from "@spartacus/core";
import { filter } from "rxjs/operators";
import { TrustedShopsService } from "../../../../../../custom/services/trustedshops.service";

@Component({
  selector: 'app-custom-product-reviews-trustedshops',
  templateUrl: './custom-product-reviews-trustedshops.component.html',
  standalone: false
})
export class CustomProductReviewsTrustedshopsComponent implements OnInit {

  product$: Observable<Product>;
  visible: boolean = false;

  constructor(private currentProductService: CurrentProductService,
              private trustedShopsService: TrustedShopsService) {
    this.visible = this.trustedShopsService.enabled;
  }

  ngOnInit(): void {
    this.product$ = this.currentProductService.getProduct().pipe(filter(isNotNullable));
  }

}
